export default "__VITE_ASSET__DhMuLYv8__"